import { createSelector, createSlice } from "@reduxjs/toolkit";

const adminListSlice = createSlice({
    name: "adminList",
    initialState: {
        userListLoading: false,
        userList: { data: [], pagination: null },

        employeListLoading: false,
        employeeList: { data: [], pagination: null },

        attendanceListLoading: false,
        attendanceList: { data: [], pagination: null },


        userDropDown: [],

        userProfile: null,
        employeeProfile: null,
        userDashboard: null,
        loadingUserProfile: false,
        loadingEmployeeProfile: false,
        allConversationsUsers: [],

        conversationUsers: [],
        trigger:null,
    },

    reducers: {
        getUserList: (state) => {
            state.userListLoading = true;
        },
        storeUserList: (state, action) => {
            // //console.log(action.payload)
            // state.userList = action?.payload?.pagination ? action.payload : { data: action?.payload?.data, pagination: null };
            state.userList = action.payload
            state.userListLoading = false;
        },
        storeUserDropdown: (state, action) => {
            state.userDropDown = action.payload
        },
        updateUser: (state) => {
            state.userListLoading = true;
        },
        getUserProfile: (state) => {
            state.loadingUserProfile = true;
        },

        refreshTrigger:(state)=>{
            state.trigger=new Date()
        },
        removeRefreshTrigger:(state)=>{
            state.trigger=null;
        },


        /***********TOTAL NO OF LEAVES********/

        employeeLeave: (state) => { },
        getEmployeeLeave: (state) => { },
        updateEmployeeLeave: (state) => { },
        getUserDashboard: (state) => { },
        storeUserDashboard: (state, action) => {
            state.userDashboard = action.payload;
        },
        getEmployeeLeaveBalance: (state) => { },





        storeUserProfile: (state, action) => {
            state.loadingUserProfile = false;
            state.userProfile = action.payload;
        },
        getEmployeeProfile: (state, action) => {
            state.loadingEmployeeProfile = true
        },
        storeEmployeeProfile: (state, action) => {
            state.loadingUserProfile = false;
            state.employeeProfile = action.payload;
        },
        assignEmployeeToTL: () => { },
        getEmployeeList: (state,action) => {
            state.employeListLoading = true;
            const employeeDetails = {
                data:action.payload?.data ?? [],
                pagination:action.payload?.pagination ?? null
            }
            state.employeeList = employeeDetails;
        },
        createEmployee: (state) => {
            state.employeListLoading = true;
        },
        updateEmployee: (state) => {
            // //console.log(state.employeeList);
        },
        storeEmployeeList: (state, action) => {
            state.employeListLoading = false;
            state.employeeList = action.payload;
        },
        reopenAttendance: (state) => { },


        getAttendanceList: (state) => {
            state.attendanceListLoading = true;
            state.attendanceList = [];
        },
        storeAttendanceList: (state, action) => {
            state.attendanceList = action.payload;
            state.attendanceListLoading = false;
        },
        turnOffLoading: (state) => {
            state.loadingUserProfile = false;
            state.attendanceListLoading = false;
            state.employeListLoading = false;
            state.userListLoading = false;
        },
        fetchAllConversationUsers: () => { },
        fetchAllUserConversationList: () => { },
        storeAllConversationUsersList: (state, action) => {
            state.conversationUsers = action.payload
        },

        fetchAllMessagesUsers: () => { },




        clearAllAdminList: (state) => {
            state.userListLoading = false
            state.userList = { data: [], pagination: null }
            state.employeListLoading = false
            state.employeeList = { data: [], pagination: null }
            state.attendanceListLoading = false
            state.attendanceList = { data: [], pagination: null }
            state.userProfile = null
            state.loadingUserProfile = false
            state.userDropDown = []
            state.conversationUsers = []
        }
    }
})

export const {
    getAttendanceList,
    getEmployeeList,
    fetchAllMessagesUsers,
    fetchAllUserConversationList,
    fetchAllConversationUsers,
    storeAllConversationUsersList,
    employeeLeave,
    removeRefreshTrigger,
    getUserDashboard,
    storeUserDashboard,
    getUserList,
    refreshTrigger,
    getEmployeeLeave,
    updateEmployeeLeave,
    getEmployeeProfile,
    storeEmployeeProfile,
    storeUserDropdown,
    storeAttendanceList,
    updateAttendanceListAdmin,
    storeEmployeeList,
    storeUserList,
    updateUser,
    createEmployee,
    updateEmployee,
    turnOffLoading,
    getUserProfile,
    storeUserProfile,
    reopenAttendance,

    assignEmployeeToTL,

    clearAllAdminList,
    getEmployeeLeaveBalance
} = adminListSlice.actions;




// Selector to extract userList and userListLoading
export const usersListSelector = createSelector(
    state => state.adminLists.userList,
    state => state.adminLists.userListLoading,
    (userList, userListLoading) => ({ data: userList, loading: userListLoading })
);

// Selector to directly extract userDropDown
export const userDropDownSelector = state => state.adminLists.userDropDown;

export const triggerSelector=state=>state.adminLists.trigger;

// Selector to extract employeeList and employeeListLoading
export const employeeListSelector = createSelector(
    state => state.adminLists.employeeList,
    state => state.adminLists.employeeListLoading,
    (employeeList, employeeListLoading) => ({ data: employeeList, loading: employeeListLoading })
);

// Selector to extract attendanceList and attendanceListLoading
export const attendanceListSelector = createSelector(
    state => state.adminLists.attendanceList,
    state => state.adminLists.attendanceListLoading,
    (attendanceList, attendanceListLoading) => ({ data: attendanceList, loading: attendanceListLoading })
);

export const dashboardSelector = createSelector(

    state => state.adminLists,
    adminLists => adminLists.userDashboard
)

export const conversationUsersListSelector = createSelector(
    state => state.adminLists,
    adminLists => adminLists.conversationUsers,
)



export default adminListSlice.reducer